import CustomFileUpload from './CustomFileUpload';

export default CustomFileUpload;
